
<div class="o-stepper">
    <ol>
        <li *ngFor="let item of navegateurData; let i=index" [ngClass]="{'o-stepper--current': i==idActive,'o-stepper--checked':i<idActive }" >
            <span class="o-stepper__indicator" aria-hidden="true">{{item.number}}</span>
            <span class="o-stepper__number">Étape {{item.number}}</span>
            <span class="o-stepper__name">{{item.name}}</span>
        </li>
    </ol>
</div>

